import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ArgoContext, FrameworkStage, FrontEndFeatureSet, useArgoContext } from '@amzn/awsscm-argo-core';

import Flashbar, { FlashbarProps } from '@amzn/awsui-components-react-v3/polaris/flashbar';

import { selectNotifications } from '../rfxportal/reducers/BuyerViewPageSlice';

export function Announcements() {
  const argoContext: ArgoContext = useArgoContext();
  const frameworkStage: FrameworkStage = argoContext.frameworkStage;
  const frontEndFeatureSet: FrontEndFeatureSet = argoContext.frontEndFeatureSet;

  const selectorNotificationData = useSelector(selectNotifications);

  const [announcements, setAnnouncement]: [
    FlashbarProps.MessageDefinition[],
    React.Dispatch<React.SetStateAction<FlashbarProps.MessageDefinition[]>>
  ] = React.useState([]);

  // Initialize announcement flashbar at first render.
  useEffect(() => {
    // Add a message if user not at production. In gamma stage, frontEndFeatureSet is 'Prerelease'
    if (frameworkStage !== FrameworkStage.prod || frontEndFeatureSet !== FrontEndFeatureSet.Release) {
      announcements.push({
        type: 'info',
        dismissible: true,
        dismissLabel: 'Dismiss message',
        content: 'You are accessing the non-production environment of this tool, ' +
          'which is intended for testing and demo purposes.',
        id: 'non_prod_info',
        onDismiss: () => setAnnouncement((items) => items.filter((item) => item.id !== 'non_prod_info'))
      });
    }
    // eslint-disable-next-line
  }, []);

  // Filter out announcements from GetNotification data
  useEffect(() => {
    const notificationData: FlashbarProps.MessageDefinition[] = selectorNotificationData
      .filter((announcement) => announcement.notificationCategory === 'ANNOUNCEMENT')
      .map((announcement) => {
        return {
          type: 'warning',
          dismissible: true,
          dismissLabel: 'Dismiss announcement',
          content: announcement.notificationText,
          id: announcement.notificationId,
          onDismiss: () =>
            setAnnouncement((announcements) =>
              announcements.filter((notification) => notification.id !== announcement.notificationId)
            )
        };
      });
    setAnnouncement([...notificationData, ...announcements]);
    // eslint-disable-next-line
  }, [selectorNotificationData]);

  return (
    <Flashbar
      items={announcements}
      i18nStrings={{
        ariaLabel: 'Announcements',
        notificationBarAriaLabel: 'View all announcements',
        notificationBarText: 'Announcements',
        errorIconAriaLabel: 'Error',
        warningIconAriaLabel: 'Warning',
        successIconAriaLabel: 'Success',
        infoIconAriaLabel: 'Info',
        inProgressIconAriaLabel: 'In progress'
      }}
      stackItems
    />
  );
}

export default Announcements;
